// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#topic-category-select-one-label, #topic-category-pinned-label {\n  text-align: left; }\n\n.btn.category-button {\n  width: 100%;\n  display: inline-flex; }\n  .btn.category-button .category-button-label {\n    max-width: 100%;\n    display: inline-block;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden; }\n\n.topic-edit-body {\n  max-height: calc( 100vh - 50px - 2rem);\n  overflow-y: auto !important; }\n", ""]);
// Exports
module.exports = exports;
